'use client';

import DownloadBanner from '@/app/[locale]/bar/components/DownloadBanner';
import { useTranslateHomeCategories } from '@/app/[locale]/bar/hooks';
import { BarStore } from '@winelivery-org/wl-client-sdk-js';
import { Experience } from '@winelivery-org/wl-client-sdk-js/src/models/experience/experience';
import { BarCategory } from '../utils';
import Categories from './components/Categories';
import Experiences from './components/Experiences';
import Location from './components/Location';

interface Props {
  store: BarStore;
  categories: { bar: BarCategory[]; take_away: BarCategory[] };
  experiences: Experience[];
}

export default function BarDetailsContent(props: Props) {
  useTranslateHomeCategories(props.categories);

  return (
    <div className={'container mx-auto px-8'}>
      <div className="py-6 space-y-6">
        <Location place={props.store.name} />
        <Categories
          data={props.categories.bar}
          barId={props.store.id}
          service="bar"
        />
        <Experiences data={props.experiences} />
        <DownloadBanner />
      </div>
    </div>
  );
}
